// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "suppression".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { suppressionChannelValues, suppressionReasonValues } from '@borradh-workspace/labels';
/** Response atom for the "suppression" table (1:1 with a DB row, on the wire). */
export const suppressionAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    channel: z.enum(suppressionChannelValues),
    contact: z.string(),
    reason: z.enum(suppressionReasonValues),
    source: z.string().nullable(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=suppression.js.map